import { render, staticRenderFns } from "./PartnersSidebar.vue?vue&type=template&id=62adb5cb&"
import script from "./PartnersSidebar.vue?vue&type=script&lang=js&"
export * from "./PartnersSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PartnersSidebar.vue?vue&type=style&index=0&id=62adb5cb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports